package com.eladfinish.bible.contest.screens.search.usecases.copy

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimAndMakafUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimIfNeedUseCase
import com.eladfinish.bible.contest.data.common.stringResolver.IStringResolver
import com.eladfinish.bible.contest.extensions.wrapWithParentheses
import com.eladfinish.bible.contest.features.copyOptions.CopyOptions
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.screens.search.ui.HighlightType
import com.eladfinish.bible.contest.searched_expression_results
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.ImmutableList

class PrepareTextToCopyUseCase(
    private val prepareSingleSearchResultToCopyUseCase: PrepareSingleSearchResultToCopyUseCase,
    private val removeNikudAndTeamimIfNeedUseCase: RemoveNikudAndTeamimIfNeedUseCase,
    private val removeNikudAndTeamimAndMakafUseCase: RemoveNikudAndTeamimAndMakafUseCase,
    private val stringResolver: IStringResolver,
) {

    operator fun invoke(
        copyOptions: CopyOptions,
        rawText: String,
    ): String =
        removeNikudAndTeamimIfNeedUseCase(
            text = rawText,
            copyOptions = copyOptions,
        )

    operator fun invoke(
        copyOptions: CopyOptions,
        highlightType: HighlightType,
        item: VerseUiModel,
    ): String =
        prepareSingleSearchResultToCopyUseCase(
            item = item,
            copyOptions = copyOptions,
            highlightType = highlightType,
        )

    operator fun invoke(
        copyOptions: CopyOptions,
        highlightType: HighlightType,
        originalExpression: String,
        items: ImmutableList<VerseUiModel>,
    ): String {
        var results = items.map { item ->
            prepareSingleSearchResultToCopyUseCase(
                item = item,
                copyOptions = copyOptions,
                highlightType = highlightType,
            )
        }.toMutableList()

        if (copyOptions.sortResults) {
            results.sortWith { s1, s2 ->
                removeNikudAndTeamimAndMakafUseCase(s1)
                    .compareTo(removeNikudAndTeamimAndMakafUseCase(s2))
            }
        }

        if (copyOptions.removeDuplicates) {
            results = results.distinct().toMutableList()
        }

        val body = results.prefixNumbersToResults()

        return if (copyOptions.includeExpression) {
            buildString {
                append("🔍 ")
                append(
                    stringResolver.resolveString(
                        SharedRes.strings.searched_expression_results.desc(),
                    ),
                )
                append(" ")
                append(originalExpression)
                append("\n")
                append(body)
            }.trim()
        } else {
            body.toString().trim()
        }
    }

    private fun List<String>.prefixNumbersToResults(): StringBuilder =
        mapIndexed { index, str ->
            (index + 1).toString().wrapWithParentheses() + " " + str
        }
            .joinToString(separator = "\n")
            .let(::StringBuilder)

}
